import { render, staticRenderFns } from "./no-datas.vue?vue&type=template&id=5b68434d&scoped=true&"
import script from "./no-datas.vue?vue&type=script&lang=js&"
export * from "./no-datas.vue?vue&type=script&lang=js&"
import style0 from "./no-datas.vue?vue&type=style&index=0&id=5b68434d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b68434d",
  null
  
)

export default component.exports